import React, { useState } from "react";
import { IconButton, Menu, MenuItem, styled } from "@mui/material";
import SortOutlinedIcon from "@mui/icons-material/SortOutlined";

const StyledMenuItem = styled(MenuItem)(() => ({
  transition: "all 0.2s linear",
  ":hover": {
    backgroundColor: "#ECF1F8"
  }
}));

interface SortProps {
  disabled: boolean;
  onChangeSort: (method: "recent" | "alphabetical" | null) => void;
  sortMethod: string | null;
}

export const Sort: React.FC<SortProps> = ({ disabled, onChangeSort, sortMethod }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const handleClose = () => {
    setAnchor(null);
  };

  const onRecentSortHandle = () => {
    if (sortMethod === "recent") {
      onChangeSort(null);
      handleClose();
      return;
    }
    onChangeSort("recent");
    handleClose();
  };

  const onAlphabetSortHandle = () => {
    if (sortMethod === "alphabetical") {
      onChangeSort(null);
      handleClose();
      return;
    }
    onChangeSort("alphabetical");
    handleClose();
  };

  return (
    <>
      <IconButton
        disabled={disabled}
        size="sm"
        onClick={(e) => {
          setAnchor(e.currentTarget);
        }}
        sx={{ bgcolor: sortMethod ? "#DBE8F5" : "#f6f8fc" }}
      >
        <SortOutlinedIcon />
      </IconButton>
      <Menu
        sx={{ ".MuiPaper-root": { borderRadius: "8px", mt: "3px" } }}
        anchorEl={anchor}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={Boolean(anchor)}
        onClose={handleClose}
      >
        <StyledMenuItem sx={{ bgcolor: sortMethod === "recent" ? "#DBE8F5" : "#f6f8fc" }} onClick={onRecentSortHandle}>
          Recent
        </StyledMenuItem>
        <StyledMenuItem
          sx={{ bgcolor: sortMethod === "alphabetical" ? "#DBE8F5" : "#f6f8fc" }}
          onClick={onAlphabetSortHandle}
        >
          A to Z
        </StyledMenuItem>
      </Menu>
    </>
  );
};
